interface Environment {
    fields?: object;
    regularExpressions?: object;
    appBaseUrl: string;
    storageBaseUrl: string;
    stripeClientApiKey: string;
    isDebugEnabled: boolean;
}

export class Configuration {
    public readonly stripeClientApiKey: string;
    public readonly appBaseUrl: string;
    public readonly storageBaseUrl: string;
    public appUrl: object;
    public fields: object;
    public regularExpressions: object;
    public storageUrl: object;
    protected appUrlPathPrefix: string;
    public isDebugEnabled: boolean;

    constructor(environment: Environment, appUrlPathPrefix: string) {
        this.fields = environment.fields ? environment.fields : {};
        const regularExpressions = environment.regularExpressions ? environment.regularExpressions : {};
        Object.keys(regularExpressions).forEach((key) => {
            const pattern = regularExpressions[key].replace(/^\//, '').replace(/\/$/, '');
            regularExpressions[key] = new RegExp(pattern);
        });
        this.regularExpressions = regularExpressions;
        this.appUrlPathPrefix = appUrlPathPrefix;
        this.appBaseUrl = environment.appBaseUrl;
        this.storageBaseUrl = environment.storageBaseUrl;
        this.stripeClientApiKey = environment.stripeClientApiKey;
        this.isDebugEnabled = !!environment.isDebugEnabled;

        this.appUrl = {
            home: this.makeAppUrl(),
        };

        this.storageUrl = {
            appLogoIcon: this.makeStorageUrl('app/app_logo_icon.png'),
            homeIcon: this.makeStorageUrl('logos/Home-Icon-Black.png'),
            backspaceIcon: this.makeStorageUrl('logos/backspace-black.png'),
            emptyIcon: this.makeStorageUrl('logos/radio_button_unchecked_black_24dp.svg'),
            checkedStampIcon: this.makeStorageUrl('logos/radio_button_checked_purple_24dp.svg'),
            stampIcon: this.makeStorageUrl('logos/verified_purple.svg'),
            appLogoText: this.makeStorageUrl('app/app_logo_text.svg'),
            punchNewImage: this.makeStorageUrl('logos/punch-new.png'),
            emptyIconUniversalImage: this.makeStorageUrl('logos/Empty-Icon-universal.png'),
            backspaceImage: this.makeStorageUrl('logos/backspace.png'),
            buy9Image: this.makeStorageUrl('logos/Buy9-icon.png'),
            freeStampImage: this.makeStorageUrl('logos/free_stamp.png'),
            animationImage: this.makeStorageUrl('logos/animation.gif'),
            instagramLogo: this.makeStorageUrl('logos/email-instagram.png'),
            yelpLogo: this.makeStorageUrl('logos/email-yelp.png'),
            facebookLogo: this.makeStorageUrl('logos/email-facebook.png'),
            mapsLogo: this.makeStorageUrl('logos/location-map-flat.png'),
            sparkLoyaltyTinyLogo: this.makeStorageUrl('logos/Loyalti_logo_tiny.png'),
            defaultBusinessLogo: this.makeStorageUrl('logos/spark-loyalty-square-4.png'),
            defaultRewardImage: this.makeStorageUrl('app/default_reward.png'),
        };
    }

    makeUrl(urlPath: string, baseUrl: string): string {
        return new URL(urlPath, baseUrl).toString();
    }

    makeAppUrl(urlPath: string = ''): string {
        return this.makeUrl(`${this.appUrlPathPrefix}/${urlPath}`, this.appBaseUrl);
    }

    makeStorageUrl(urlPath: string): string {
        return this.makeUrl(urlPath, this.storageBaseUrl);
    }
}
